import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ArrayUtils } from "neo-common/Engine/Utils/ArrayUtils";
import { Tweens, TweensAttributes } from "../Components/Effects/Tweens";
import { Attributes } from "../Utils/Attributes";
import { StringUtils } from "neo-common/Engine/Utils/StringUtils";

/**
 * SwitchElement class is class which creates holder for other elements and holds cases which can change children by switching cases.
 * Can be defined only with SwitchStyle (See SwitchStyle class).
 * Default case is NONE.
 * Example 1:
 *   <SwitchElement Class="SwitchElement" Style="SwitchStyle" />
 *
 * @class FireFlieElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class FireFlieElement extends SwitchElement {
    protected originX: number;
    protected originY: number;
    protected randomX: number;
    protected randomY: number;
    protected finalX: number;
    protected finalY: number;
    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    createByNode(node: Element) {
        if (node.hasAttribute("X")) {
            this.originX = parseInt(node.getAttribute("X"));
        }

        if (node.hasAttribute("Y")) {
            this.originY = parseInt(node.getAttribute("Y"));
        }

        if (node.hasAttribute("RandomX")) {
            this.randomX = parseInt(node.getAttribute("RandomX"));
        }

        if (node.hasAttribute("RandomY")) {
            this.randomY = parseInt(node.getAttribute("RandomY"));
        }

        if (node.hasAttribute("FinalX")) {
            this.finalX = parseInt(node.getAttribute("FinalX"));
        }

        if (node.hasAttribute("FinalY")) {
            this.finalY = parseInt(node.getAttribute("FinalY"));
        }

        super.createByNode(node);
    }

    updateByNode(node: Element) {
        super.updateByNode(node);
    }

    start(delay: number = 0): void {
        this.runCustomBezierTween(delay);
    }

    setOrigin(): void {
        this.position.x = this.originX;
        this.position.y = this.originY;
    }

    /**
     * Clone method used for cloning instance of this element with his main properties.
     * @method clone
     * @return FireFlieElement
     */
    clone(): FireFlieElement {
        const element: FireFlieElement = new FireFlieElement();

        element.style = this.style;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;

        element.originX = this.originX;
        element.originY = this.originY;
        element.randomX = this.randomX;
        element.randomY = this.randomY;

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.case = this.case;

        element.markAsCloned(); // must be called last before return!
        return element;
    }

    hide(): void {
        this.goToCase("HIDE");
    }

    goToCase(s: string, emitEvent: boolean = false): void {
        super.goToCase(s, emitEvent);
    }

    /**
     *
     * @param node
     */
    public runCustomBezierTween(delay: number = 0): void {
        Tweens.removeTweens(this);
        let bezierX: Array<number> = null;
        let bezierY: Array<number> = null;
        let bezier: any = null;

        bezierX = [this.originX, this.finalX];
        bezierY = [this.originY, this.finalY];
        bezier = { values: [] };

        for (let i = 0; i < Math.min(bezierX.length, bezierY.length); i++) {
            bezier.values.push({ x: bezierX[i], y: bezierY[i] });
        }

        const tweenEase: string = null;
        const tweenDuration: number = 30;
        const tweenDelay: number = delay;
        const tweenLoop: boolean = null;

        Tweens.bezierTween(this, {
            bezier,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop,
            callbackFunction: this.hide,
            callbackType: "onComplete",
            callbackScope: this,
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/FireFlieElement.ts
 **/